import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgForm, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { decryptValue } from '../shared/data/encryption';
import { formatDate } from '@angular/common';
import swal from 'sweetalert2';
import imageCompression from 'browser-image-compression';
import {webURL} from '../shared/data/urls'

@Component({
  selector: 'app-lab-samples',
  templateUrl: './lab-samples.component.html',
  styleUrls: ['./lab-samples.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabSamplesComponent implements OnInit {
  labSamplesForm: FormGroup;
  userName: string = "";
  decryptedBaseUrl: string = "";
  samplePointArray: Object[] = [];
  selectedSample: any = "";
  isComposite: boolean = false;
  selectedSampleId: number = 0;
  companyMasterDataForCount: any;
  selectedSampleState: string = null;
  labFileNumber: string = "";
  filteredSamplePointCode :any = []
  baseTemperature:any;
  currentDate:any;
  showCalibirationDate : boolean = false;
  selectedOperatorId : any;
  isCustomer : boolean = false;
  operatorsOfCustomer : any;
  availableReportTests :any= [];
  qrCodeDataUrl : any;
  scannedResult: string | null = null;
  selectedDevice: MediaDeviceInfo | null = null;
  isMobile: boolean = false;
  disableSamplePointCode :boolean = false;
  barCodeOfSample : any;
  displayLoading: boolean = false;
  originalFileSize : any;
  compressedFileSize : any;
  capturedBarCode : any;
  pagetype : any;
  sampleDataExisted : any;
  sampleStatus :any;
  labSampleLabelMap: any = {};

  constructor(private http: HttpClient, private formBuilder: FormBuilder, private router: Router, private changedetector: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.userName = decryptValue(localStorage.getItem('UserName'));
    this.decryptedBaseUrl = decryptValue(localStorage.getItem('BaseURL'));
    this.isCustomer = localStorage.getItem('IsCustomer') ? decryptValue(localStorage.getItem('IsCustomer')) == "Y" ? true : false : false;
    this.operatorsOfCustomer = localStorage.getItem('operator') ? decryptValue(localStorage.getItem('operator')) : [];
   // this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
   this.isMobile = localStorage.getItem('isMobile') ? decryptValue(localStorage.getItem('isMobile')) == "true" : false;
    
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0];

    if(this.isCustomer){
       this.availableReportTests = [{
        value : "C6",
        title : "C6"
       },
       {
        value : "C9",
        title : "C9"
       }
      ]
    } else{
       this.availableReportTests = [
        {
        value : "C6",
        title : "C6"
       },
       {
        value : "C9",
        title : "C9"
       },
       {
        value : "EXTENDED ANALYSIS",
        title : "EXTENDED ANALYSIS"
       },
       {
        value : "H2S",
        title : "H2S"
       },
       {
        value : "RVP",
        title : "RVP"
       },
       {
        value : "SULFUR SPECIATION",
        title : "SULFUR SPECIATION"
       },
       {
        value : "API",
        title : "API"
       },
       {
        value : "SPECIFIC GRAVITY",
        title : "SPECIFIC GRAVITY"
       }
       ]
    }

    this.labSamplesForm = new FormGroup({
      'samplePointCode': new FormControl(null, [Validators.required]),
      'samplePointName': new FormControl(null),
      'workOrder': new FormControl(null),
      'labFileNumber': new FormControl(null),
      'containerNumber': new FormControl(null),
      'sourceLab': new FormControl('Premier Measurement and Laboratory Services'),
      'code': new FormControl(null),
      'location': new FormControl(null),
      'name': new FormControl(null),
      'product': new FormControl(null),
      'operator': new FormControl(null),
      'facilityCode': new FormControl(null),
      'dataTransfer': new FormControl(null),
      'email': new FormControl(null),
      'effectiveDate': new FormControl(null),
      'effectiveTime': new FormControl(null),
      'pressure': new FormControl(null),
      'temperature': new FormControl(null),
      'exportCode': new FormControl(null),
      'exportClient': new FormControl(null),
      'samplerName': new FormControl(null),
      'sampleType': new FormControl(null),
      'sampleState': new FormControl(null, [Validators.required]),
      'sampleDate': new FormControl(null, [Validators.required]),
      'sampleTime': new FormControl(null),
      'fromDate': new FormControl(null),
      'endDate': new FormControl(null),
      'calibarationDate' : new FormControl(null),
      'sourceDescription': new FormControl(null),
      'flowRate': new FormControl(null),
      'flowRateUnit': new FormControl(null),
      'ambientTemperature': new FormControl(null),
      'ambientTemperatureUnit': new FormControl(null),
      'sourcePressure': new FormControl(null),
      'basePressure': new FormControl(null, [Validators.required]),
      'basePressureUnit': new FormControl(null),
      'sourcePressureUnit': new FormControl(null),
      'sourceTemperature': new FormControl(null),
      'sourceTemperatureUnit': new FormControl(null),
      'fieldH2SValue': new FormControl(null),
      'fieldH2SValueUnit': new FormControl(null),
      'fieldH2SMethod': new FormControl(null),
      'fieldH2OValue': new FormControl(null),
      'fieldH2OValueUnit': new FormControl(null),
      'fieldH2OMethod': new FormControl(null),
      'reportType': new FormControl(null),
      'reportTests': new FormControl(null, [Validators.required]),
      'reportOthers': new FormControl(null),
      'lease': new FormControl(null),
      'sampleEndDate': new FormControl(null),
      'samplingMethod': new FormControl(null),
      'companyCollectingSample': new FormControl(null),
      'C6Composition' : new FormControl(''),
      'C7Composition' : new FormControl(''),
      'C8Composition' : new FormControl(''),
      'baseTemperature' : new FormControl(''),
      'laboratory' : new FormControl(''),
      'technician' : new FormControl(''),
      // 'timeCollected' : new FormControl(null),
      'sampleCondition' : new FormControl(null),
      'additionalNotes' : new FormControl(null)
    }, { updateOn: 'blur' });

    if(localStorage.getItem('dashboardData') != null){
      localStorage.removeItem('dashboardData')
    }

    if(this.isMobile && localStorage.getItem('SampleData')) {
      const sampleData = JSON.parse(decryptValue(localStorage.getItem('SampleData')))
      console.log("sampleData", sampleData)
      if(localStorage.getItem('SampleData')){
        this.disableSamplePointCode = true
      } else{
        this.disableSamplePointCode = false
      }
      console.log("sample Data from params", sampleData)
      this.labSamplesForm.get('basePressure').setValue(sampleData.BASE_PRESSURE)
      this.labSamplesForm.get('sampleDate').setValue(this.currentDate)
      this.labSamplesForm.get('sampleState').setValue(sampleData.SAMPLE_STATE)
      this.labSamplesForm.get('reportTests').setValue(sampleData.REPORT.TESTS)
      // this.labSamplesForm.get('C6Composition').setValue(sampleData.C6Composition)
      // this.labSamplesForm.get('C7Composition').setValue(sampleData.C7Composition)
      // this.labSamplesForm.get('C8Composition').setValue(sampleData.C8Composition)
      // this.labSamplesForm.get('samplerName').setValue(sampleData.SAMPLER_NAME)
      // this.labSamplesForm.get('sourceDescription').setValue(sampleData.SOURCE_DESCRIPTION)
      // this.labSamplesForm.get('basePressureUnit').setValue(sampleData.UNITS.basePressureUnit)
      this.selectedSampleState = sampleData.SAMPLE_STATE
      this.selectedOperatorId = sampleData.OPERATOR
      let splitSampleData = sampleData.CODE.split("|");
      this.labSamplesForm.patchValue({ samplePointCode: splitSampleData[0].trim(), samplePointName: splitSampleData[1].trim(), lease: splitSampleData[1].trim(), code: sampleData.CODE });
      this.selectedSample = splitSampleData[0].trim();
      this.selectedSampleId = sampleData.SAMPLE_ID
      this.generateLabFileNumber()
    }

   // this.getCompanyMasterData();
   this.getConfigDataforBaseTemp()
   console.log("is mobile condition", this.isMobile, this.route.snapshot.queryParamMap.get('id'))
   console.log("212------", !this.isMobile && !this.route.snapshot.queryParamMap.get('id'))

    if (this.route.snapshot.queryParamMap.get('id')) {
      this.pagetype = 'edit'
      this.setSampleData(this.route.snapshot.queryParamMap.get('id'));
    } else {
      this.pagetype = 'add'
    }
    if (!this.isMobile && !this.route.snapshot.queryParamMap.get('id')) {
      this.labSamplesForm.reset()
    }

   console.log("report Tests", this.labSamplesForm.value.reportTests)
   this.labSamplesForm.get('samplerName').setValue(this.userName);
   this.labSamplesForm.get('fieldH2SMethod').setValue('STAIN');
  }

  setSampleData(sampleId) {
    this.http.get<any>(this.decryptedBaseUrl + `/lab_samples_service/lab_samples/${sampleId}`)
      .subscribe((data) => {
        console.log("Sample Data from id", data)
        const sampleData = data[0];
        this.sampleStatus = sampleData.STATUS
        this.sampleDataExisted = sampleData;
        this.selectedSampleState = sampleData.SAMPLE_STATE
        this.selectedOperatorId = sampleData.OPERATOR
        this.selectedSampleId = sampleId

        let splitSampleData = sampleData.CODE.split("|");
        this.selectedSample = splitSampleData[0].trim();
        console.log("splitSampleData", splitSampleData[0].trim())
        this.labSamplesForm.patchValue({
          samplePointCode: splitSampleData[0].trim(),
          samplePointName: splitSampleData[1].trim(),
          code: sampleData.CODE,
          workOrder: sampleData?.WORK_ORDER,
          labFileNumber: sampleData?.LAB_FILE_NUMBER,
          containerNumber: sampleData?.CONTAINER_NUMBER,
          sourceLab: sampleData?.SOURCE_LAB,
          samplerName: sampleData?.SAMPLER_NAME,
          sampleType: sampleData?.SAMPLE_TYPE,
          sampleDate: sampleData?.SAMPLE_DATE ? sampleData?.SAMPLE_DATE.split('T')[0] : null,
          sampleState : sampleData?.SAMPLE_STATE,
          sampleTime: sampleData?.SAMPLE_TIME,
          fromDate: sampleData?.FROM_DATE,
          endDate: sampleData?.END_DATE ? sampleData?.END_DATE.split('T')[0] : null,
          sourceDescription: sampleData?.SOURCE_DESCRIPTION,
          flowRate: sampleData?.FLOW_RATE,
          flowRateUnit: sampleData?.UNITS?.flowRateUnit,
          ambientTemperature: sampleData?.AMBIENT_TEMPERATURE,
          ambientTemperatureUnit: sampleData?.UNITS?.ambientTemperatureUnit,
          basePressure: sampleData?.BASE_PRESSURE,
          basePressureUnit: sampleData?.UNITS?.basePressureUnit,
          sourcePressure: sampleData?.SOURCE?.PRESSURE,
          sourcePressureUnit: sampleData?.UNITS?.sourcePressureUnit,
          sourceTemperature: sampleData?.SOURCE?.TEMPERATURE,
          sourceTemperatureUnit: sampleData?.UNITS?.sourceTemperatureUnit,
          fieldH2SValue: sampleData?.FIELDH2S?.VALUE,
          fieldH2SValueUnit: sampleData?.UNITS?.fieldH2SValueUnit,
          fieldH2SMethod: sampleData?.FIELDH2S?.METHOD,
          fieldH2OValue: sampleData?.FIELDH2O?.VALUE,
          fieldH2OValueUnit: sampleData?.UNITS?.fieldH2OValueUnit,
          fieldH2OMethod: sampleData?.FIELDH2O?.METHOD,
          reportType: sampleData?.REPORT?.TYPE,
          reportTests: sampleData?.REPORT?.TESTS,
          reportOthers: sampleData?.REPORT?.OTHERS,
          lease: splitSampleData[1].trim(),
          samplingMethod: sampleData?.SAMPLING_METHOD,
          calibarationDate : sampleData.VALIDATION_DATE ? sampleData.VALIDATION_DATE.split('T')[0] : null,
          companyCollectingSample: sampleData?.COMPANY_COLLECTING_SAMPLE,
          C6Composition : sampleData?.C6Composition,
          C7Composition : sampleData?.C7Composition,
          C8Composition : sampleData?.C8Composition,
          sampleCondition : sampleData?.SAMPLE_CONDITION,
          additionalNotes : sampleData?.ADDITIONAL_NOTES,
        });
        this.changedetector.detectChanges()
      });

  }

  getConfigDataforBaseTemp(){
    const module = "CREATE_SAMPLE"
    this.http.get<any>(this.decryptedBaseUrl + `/config_details_service/config_details/CONFIG_MODULE/${module}`)
      .subscribe((data) => {
        data.map((item) => {
          if (item.CONFIG_FIELD_NAME == 'Base Temperature') {
            this.baseTemperature = item.CONFIG_FIELD_VALUE
            this.labSamplesForm.get('baseTemperature').setValue(`${this.baseTemperature}°F`);
          }
        })
      })
    console.log("3");
    this.changedetector.detectChanges();
  }

  onClickSave(action) {
    if (this.labSamplesForm.valid) {
      this.displayLoading = true;
      const date = this.labSamplesForm.get('sampleDate').value; // e.g., '2024-09-27'
      const time = this.labSamplesForm.get('sampleTime').value; // e.g., '14:30'
      var dateSampled 
      if (date && time) {
        console.log("Time",time)
        // Combine date and time into a single DateTime string
        const combinedDateTime = new Date(`${date}T${time}:00`); // '2024-09-27T14:30:00'
        console.log('Combined DateTime:', combinedDateTime);
        dateSampled = combinedDateTime.toISOString() // Storing as GMT in db
         
        // Store this combinedDateTime in the database
        // Call your backend service here to store the combined dateTime
      }else{
 
        const currentDate = new Date()
        const currentHours = currentDate.getHours().toString().padStart(2, '0'); // Gets the current hours (0-23)
        const currentMinutes = currentDate.getMinutes().toString().padStart(2, '0'); // Gets the current minutes (0-59)
        const time = `${currentHours}:${currentMinutes}`
        console.log("Time",time)
        const localDate = new Date(`${date}T${time}`)
        dateSampled = localDate.toISOString()
      }
      console.log("dateSampled",dateSampled)

      const currentDate = new Date()
      const currentHours = currentDate.getHours().toString().padStart(2, '0'); // Gets the current hours (0-23)
      const currentMinutes = currentDate.getMinutes().toString().padStart(2, '0'); // Gets the current minutes (0-59)
      const currenttime = `${currentHours}:${currentMinutes}`
      console.log("sample end date",this.labSamplesForm.value.sampleEndDate)
      var sampleEndDate = this.labSamplesForm.value.sampleEndDate ? new Date(`${this.labSamplesForm.value.sampleEndDate}T${currenttime}`).toISOString() : null
      console.log("sampleEndDate",sampleEndDate)

      const data = {
        SAMPLE_POINT_CODE: this.labSamplesForm.value.samplePointCode,
        SAMPLE_POINT_NAME: this.labSamplesForm.value.samplePointName,
        WORK_ORDER: this.labSamplesForm.value.workOrder,
        LAB_FILE_NUMBER: this.labSamplesForm.value.labFileNumber,
        CONTAINER_NUMBER: this.labSamplesForm.value.containerNumber,
        SOURCE_LAB: this.labSamplesForm.value.sourceLab,
        SAMPLER_NAME: this.labSamplesForm.value.samplerName,
        SAMPLE_TYPE: this.labSamplesForm.value.sampleType,
        SAMPLE_DATE: dateSampled,
        SAMPLE_TIME: this.labSamplesForm.value.sampleTime,
        FROM_DATE: this.labSamplesForm.value.fromDate,
        END_DATE: this.labSamplesForm.value.endDate,
        SOURCE_DESCRIPTION: this.labSamplesForm.value.sourceDescription,
        FLOW_RATE: this.labSamplesForm.value.flowRate,
        AMBIENT_TEMPERATURE: this.labSamplesForm.value.ambientTemperature,
        BASE_PRESSURE: this.labSamplesForm.value.basePressure,
        SOURCE: { PRESSURE: this.labSamplesForm.value.sourcePressure, TEMPERATURE: this.labSamplesForm.value.sourceTemperature },
        FIELDH2S: { VALUE: this.labSamplesForm.value.fieldH2SValue, METHOD: this.labSamplesForm.value.fieldH2SMethod },
        FIELDH2O: { VALUE: this.labSamplesForm.value.fieldH2OValue, METHOD: this.labSamplesForm.value.fieldH2OMethod },
        REPORT: { TYPE: this.labSamplesForm.value.reportType, TESTS: this.labSamplesForm.value.reportTests, OTHERS: this.labSamplesForm.value.reportOthers },
        UNITS: {
          flowRateUnit: this.labSamplesForm.value.flowRateUnit,
          ambientTemperatureUnit: this.labSamplesForm.value.ambientTemperatureUnit,
          sourcePressureUnit: this.labSamplesForm.value.sourcePressureUnit,
          sourceTemperatureUnit: this.labSamplesForm.value.sourceTemperatureUnit,
          fieldH2SValueUnit: this.labSamplesForm.value.fieldH2SValueUnit,
          fieldH2OValueUnit: this.labSamplesForm.value.fieldH2OValueUnit,
          basePressureUnit: this.isCustomer ? "PSI" : this.labSamplesForm.value.basePressureUnit
        },
        CODE: this.labSamplesForm.value.code,
        LEASE: this.labSamplesForm.value.lease,
        SAMPLE_END_DATE: sampleEndDate,
        SAMPLING_METHOD: this.labSamplesForm.value.samplingMethod,
        VALIDATION_DATE : this.labSamplesForm.value.calibarationDate,
        COMPANY_COLLECTING_SAMPLE: this.labSamplesForm.value.companyCollectingSample,
        CREATED_BY: this.userName,
        C6Composition : this.labSamplesForm.value.C6Composition,
        C7Composition : this.labSamplesForm.value.C7Composition,
        C8Composition : this.labSamplesForm.value.C8Composition,
        STATUS: "NEW",
        SAMPLE_STATE : this.selectedSampleState,
        LABORATORY : this.labSamplesForm.value.sourceLab,
        TECHNICIAN : this.labSamplesForm.value.samplerName,
        OPERATOR : this.selectedOperatorId,
        CREATED_ON: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss', 'en-US', 'UTC'),
        SAMPLE_CONDITION: this.labSamplesForm.value.sampleCondition,
        ADDITIONAL_NOTES: this.labSamplesForm.value.additionalNotes,
       // BARCODE_ON_SAMPLE : this.barCodeOfSample ? this.barCodeOfSample.split(',')[1] : null, // Extract base64 part if needed
      }  

      var createSampleBody = {}
      var updateSampleBody = {}
      // company Master Data
      if (action == 'save') {
        let updatedSampleCount: number = this.companyMasterDataForCount.company_master.COMPANY_COUNT + 1;
        let companyMasterBody = {
          COMPANY_COUNT: updatedSampleCount,
          LAST_MODIFIED_ON: new Date(),
          LAST_MODIFIED_BY: this.userName,
          companyId: this.companyMasterDataForCount.company_master.id
        };
        // audit data
        const auditBody = {
          DESCRIPTION: 'CREATED',
          COMMENTS: `created the sample`,
          CREATED_BY: this.userName,
          CREATED_ON: new Date()
        }

        createSampleBody = {
          labSampleData: data,
          companyMasterBody: companyMasterBody,
          auditBody: auditBody
        }

        console.log("Body", createSampleBody)

        
      }
      else if (action == 'update') {
        delete data["CREATED_BY"]
        delete data["CREATED_ON"]
        data["STATUS"] = this.sampleDataExisted.STATUS
        data["LASTMODIFIED_BY"] = this.userName
        data["LASTMODIFIED_ON"] =  formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss', 'en-US', 'UTC')
        var auditBody = []
       
        const sampleDataKeys = Object.keys(this.sampleDataExisted).filter(item => !['id', 'CREATED_ON','LASTMODIFIED_ON', 'LASTMODIFIED_BY'].includes(item));
        
        console.log("sampleDataKeys",sampleDataKeys)

        sampleDataKeys.forEach(key => {
          console.log("Con", this.sampleDataExisted[key] != data[key] && ((this.sampleDataExisted[key] == null || this.sampleDataExisted[key] == undefined) && !!data[key]), key)
          // console.log("key", key, this.sampleDataExisted[key], data[key])
          // console.log("labSamplesForm", data[key])
        //  console.log("type of key", typeof key == 'object' ,typeof key, key)
       
          if(key == 'VALIDATION_DATE' || key == 'SAMPLE_DATE'){
            const validationDate = this.sampleDataExisted[key] ? new Date(this.sampleDataExisted[key]).toISOString().split('T')[0] : null;
            const newValidationDate = data[key] ? new Date(data[key]).toISOString().split('T')[0] : null;
            if (validationDate !== newValidationDate && newValidationDate) {
              auditBody.push({
                SAMPLE_ID: this.sampleDataExisted.id,
                DESCRIPTION: 'UPDATED',
                COMMENTS: `Updated ${key} from ${validationDate} to ${newValidationDate}`,
                CREATED_BY: this.userName,
                CREATED_ON: new Date()
              });
            }
          }

          else if (this.sampleDataExisted[key] != data[key] && ((this.sampleDataExisted[key] == null || this.sampleDataExisted[key] == undefined) && !!data[key])) {
            console.log("entered 460")
            auditBody.push({
              SAMPLE_ID: this.sampleDataExisted.id,
              DESCRIPTION: 'UPDATED',
              COMMENTS: `Updated the sample added ${data[key]} for ${key}`,
              CREATED_BY: this.userName,
              CREATED_ON: new Date()
            });
          }

          else if (typeof this.sampleDataExisted[key] == 'object' && key) {
            const keysObject = this.sampleDataExisted[key] ? Object.keys(this.sampleDataExisted[key]) : [];
            // console.log("keysObject", keysObject, typeof key)
            if(keysObject.length > 0) {
            keysObject.forEach(objKey => {
              const existingObjValue = this.sampleDataExisted[key]?.[objKey] ? this.sampleDataExisted[key][objKey] : null;
              const newObjValue = data[key]?.[objKey] ? data[key]?.[objKey] : null;
              if (existingObjValue !== newObjValue && newObjValue) {
                auditBody.push({
                  SAMPLE_ID: this.sampleDataExisted.id,
                  DESCRIPTION: 'UPDATED',
                  COMMENTS: `Updated ${key}.${objKey} from ${existingObjValue} to ${newObjValue}`,
                  CREATED_BY: this.userName,
                  CREATED_ON: new Date()
                });
              }
            });
          }
          }   

          else if (this.sampleDataExisted[key] !== data[key] && !!this.sampleDataExisted[key] && !!(data[key])) {
            auditBody.push({
              SAMPLE_ID: this.sampleDataExisted.id,
              DESCRIPTION: 'UPDATED',
              COMMENTS: `Updated ${key} from ${this.sampleDataExisted[key]} to ${data[key]}`,
              CREATED_BY: this.userName,
              CREATED_ON: new Date()
            });
          }


        });
        data["id"] = this.sampleDataExisted.id;
        updateSampleBody = {
          labSampleData: data,
          auditBody: auditBody
        }   
        console.log("Update Body", data)
        console.log("auditBody", auditBody);
      }
      console.log("c6", this.labSamplesForm.value.C6Composition)
      if (this.labSamplesForm.value.C6Composition  || this.labSamplesForm.value.C7Composition  || this.labSamplesForm.value.C8Composition) {
        var sumOfCompositions = (parseFloat(this.labSamplesForm.value.C6Composition)) + parseFloat(this.labSamplesForm.value.C7Composition) + parseFloat(this.labSamplesForm.value.C8Composition)
        console.log("sumOfCompositions", sumOfCompositions)
        if (sumOfCompositions == 100) {
          if (action == 'update') {
            if (updateSampleBody["auditBody"].length > 0) {
              this.updateSampleData(updateSampleBody)
            } else if (updateSampleBody["auditBody"].length == 0) {
              swal.fire("Warning", "No fields are updated", "warning");
            }
          } else {
            this.createSampleData(createSampleBody)
          }
        } else {
          this.displayLoading = false
          swal.fire("Warning", "The compositions added should sum upto 100", "warning");
        }
      } else {
        if (action == 'update') {
          this.updateSampleData(updateSampleBody)
        } else {
          this.createSampleData(createSampleBody)
        }
      }
     

    }
    else {
      this.labSamplesForm.markAllAsTouched();
      this.changedetector.detectChanges();
    }
  }

  onClickUpdate() {
    // Prepare the audit body
    this.onClickSave('update');

  }

  updateSampleData(body) {
    this.http.post<any>(this.decryptedBaseUrl + "/lab_samples_service/update/lab_samples/create/auditLog", body)
      .subscribe((res) => {
        console.log("Successfully Updated", res)
        this.displayLoading = false;
        swal.fire(
          "Success!",
          `Sample has been updated successfully`,
          "success"
        ).then(() => {
          this.router.navigate(['/sample/listing']);
        })
      }, (err) => {
        console.log("err", err)
        this.displayLoading = false;
        swal.fire(
          "Error!",
          `Please try again there is a error in updating the sample`,
          "error"
        );
      })
  }

  createSampleData(body) {
      this.http.post<any>(this.decryptedBaseUrl + '/lab_samples_service/create/lab_samples/update/companyMaster', body)
            .subscribe((labSamples) => {
              if(this.isMobile && this.capturedBarCode) {
               this.uploadBarCodeOfSample(this.labSamplesForm.value.labFileNumber, labSamples.id);
              }
              console.log("Successfully Added", labSamples)  
              if(this.isMobile) {
              this.createQRCodeSamplePointCodeMapping(labSamples)  
              }
              this.selectedSample = null;
              this.clearForm();
              this.displayLoading = false;
              swal.fire(
                "Success!",
                `Sample has been created successfully`, 
                "success"
              ).then(() => {
                this.router.navigate(['/sample/listing']);
              })
              // swal.fire({
              //   html: `
              //     <h3 style="margin:0 0 12px 0; font-weight:600;">Sample Created Successfully</h3>
              //     <p style="margin:0 0 8px 0;"><strong>File Number:</strong> ${this.labFileNumber}</p>
              //     <p style="margin:0;">What would you like to do next?</p>
              //   `,
              //   showCancelButton: true,
              //   confirmButtonText: 'OK',
              //   cancelButtonText: 'Generate QR Code',
              //   reverseButtons: true
              // })
              // .then((result) => {
              //   if (result.isConfirmed) {
              //     setTimeout(() => {
              //       this.router.navigate(['/sample/listing']);
              //     }, 500);
              //   }
              //   else if (result.isDismissed && result.dismiss === swal.DismissReason.cancel) {
              //     // 👇 QR Code generation logic
              //     this.generateQRCode(body.labSampleData, labSamples.id);
              //   }
              // });         
            }, (err) => {
              console.log("err", err)
              this.displayLoading = false;
              swal.fire(
                "Error!",
                `Please try again there is a error in the sample`,
                "error"
              );
            })
  }

  createQRCodeSamplePointCodeMapping(labSamples) {
    const body = {
      QRCodeSerialId : decryptValue(localStorage.getItem('QRSerialId')),
      SAMPLE_POINT_CODE : labSamples.CODE,
      LATEST_SAMPLE_ID : labSamples.id,
      SAMPLE_POINT_CODE_ID : this.selectedSampleId,
      user : this.userName
    }
    console.log("QR Sample Point Code Mapping Body", body)
    this.http.post<any>(this.decryptedBaseUrl + `/qr_samplepointcode_mapping_service/create/qr_samplepointcode_mappings`, body)
      .subscribe((data) => {
        console.log("QR Sample Point Code Mapping Created", data)
      })
  }

  uploadBarCodeOfSample(labFileNumber,sampleId) {
    const formData: FormData = new FormData();
      // formData.append('file', this.selectedFile, this.selectedFile.name);
      const filePath = `${labFileNumber}/${this.capturedBarCode.name}`
      formData.append("file", this.capturedBarCode);
      formData.append("contentType", this.capturedBarCode.type);
      formData.append("filePath", filePath);
      console.log("Captured Bar Code", this.capturedBarCode, this.capturedBarCode.name, this.capturedBarCode.type);
      console.log("formData", formData);

      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');

      this.http.post<any>(this.decryptedBaseUrl + '/get_files_service/uploadBarCodeOfSample', formData)
          .subscribe((resp) => {
             const body = {
              LASTMODIFIED_ON: new Date(),
              LASTMODIFIED_BY: this.userName,
              BARCODE_ON_SAMPLE : "Y"
             }
             this.http.put<any>(this.decryptedBaseUrl + "/lab_samples_service/lab_samples/" + sampleId, body)
             .subscribe(data => {
               
             })
             
          })
  }

  async onUploadImage(event: any) {
    this.capturedBarCode = event.target.files[0];
  }


  generateQRCode(addSampleData, createdLabSampleId) {
    console.log("createdLabSampleId", createdLabSampleId)
    console.log("addSampleData", addSampleData)
    const payloadBody = {
        SAMPLE_POINT_CODE: addSampleData.SAMPLE_POINT_CODE,
        SAMPLE_POINT_NAME: addSampleData.SAMPLE_POINT_NAME,
        SAMPLE_ID : this.selectedSampleId,
       // LAB_FILE_NUMBER: addSampleData.LAB_FILE_NUMBER,
        // CONTAINER_NUMBER: addSampleData.CONTAINER_NUMBER,
        // SOURCE_LAB: addSampleData.SOURCE_LAB,
        // SAMPLER_NAME: addSampleData.SAMPLER_NAME,
        SAMPLE_TYPE: addSampleData.SAMPLE_TYPE,
       // SOURCE_DESCRIPTION: addSampleData.SOURCE_DESCRIPTION,
        BASE_PRESSURE: addSampleData.BASE_PRESSURE,
        REPORT:  addSampleData.REPORT,
        // UNITS: {
        //   flowRateUnit: this.labSamplesForm.value.flowRateUnit,
        //   ambientTemperatureUnit: this.labSamplesForm.value.ambientTemperatureUnit,
        //   sourcePressureUnit: this.labSamplesForm.value.sourcePressureUnit,
        //   sourceTemperatureUnit: this.labSamplesForm.value.sourceTemperatureUnit,
        //   fieldH2SValueUnit: this.labSamplesForm.value.fieldH2SValueUnit,
        //   fieldH2OValueUnit: this.labSamplesForm.value.fieldH2OValueUnit,
        //   basePressureUnit: this.isCustomer ? "PSI" : this.labSamplesForm.value.basePressureUnit
        // },
         CODE: addSampleData.CODE,
        // LEASE: addSampleData.LEASE,
        // C6Composition : addSampleData.C6Composition,
        // C7Composition : addSampleData.C7Composition,
        // C8Composition : addSampleData.C8Composition,
        SAMPLE_STATE : addSampleData.SAMPLE_STATE,
        // LABORATORY : addSampleData.LABORATORY,
        // TECHNICIAN : addSampleData.TECHNICIAN,
        OPERATOR : addSampleData.OPERATOR,
      }
    const body = {
      sampleData : payloadBody,
      webSiteUrl : webURL.URL,
      createdSampleId : createdLabSampleId
    }
    console.log("Payload", payloadBody)
    this.http.post<any>(this.decryptedBaseUrl + '/lab_samples_service/generateQRCode', body)
      .subscribe((res) => {
        this.qrCodeDataUrl = res.qrCode;
        swal.fire({
          title: 'Scan this QR Code',
          html: `<img src="${res.qrCode}" alt="QR Code" style="width: 200px; height: 200px;" />
          <p style="margin:0 0 8px 0;"><strong>Lab File Number : ${addSampleData.LAB_FILE_NUMBER}</p>
          <p style="margin:0 0 8px 0;"><strong>Sample Point Name : ${addSampleData.SAMPLE_POINT_NAME}</p>
          `,
          confirmButtonText: 'Close'
        })
          .then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/sample/listing']);
            }
          })
      })
  }

  clearForm() {
    this.labSamplesForm.reset();
    this.selectedSampleState = "";
    this.selectedSample = "";
  }

  samplerTypeSelection(event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;

    if (selectedValue == "Composite") {
      this.isComposite = true;
    }
    else {
      this.isComposite = false;
    }
  }

  reportTypeSelection(event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;
    if (selectedValue == "C9") {
      this.showCalibirationDate = true;
    }
    else {
      this.labSamplesForm.patchValue({ laboratory: null });
      this.labSamplesForm.patchValue({ technician: null });
      this.labSamplesForm.patchValue({ calibarationDate: null });
      this.showCalibirationDate = false;
    }
  }

  samplerPointSelection() {

    if (this.selectedSample != null) {

      this.labSamplesForm.get('samplePointCode').markAsTouched();
      console.log("Selected Sample", this.selectedSample);
      this.selectedSampleId = this.selectedSample.ID;
      this.selectedOperatorId = this.selectedSample.operator
      let splitSampleData = this.selectedSample.SAMPLE.split("|");
      this.labSamplesForm.patchValue({ samplePointCode: splitSampleData[0].trim(), samplePointName: splitSampleData[1].trim(), lease: splitSampleData[1].trim(), code: this.selectedSample.SAMPLE });
      this.selectedSample = splitSampleData[0].trim();
      this.getLabSampleConfigData(this.selectedOperatorId)
    }
    else {
      this.labSamplesForm.patchValue({ samplePointCode: "", samplePointName: "", code: "", lease: "" });

    }

    if (this.selectedSampleState != null) {
      this.generateLabFileNumber();
    }
    
    this.filteredSamplePointCode = []
    // else {
    //   swal.fire("Warning", "Please select the sample state to generate the file number", 'info');
    // }
  }

  getLabSampleConfigData(operatorId) {
    this.displayLoading = true;
    this.http.get<any>(this.decryptedBaseUrl + '/report_config_service/get_report_config/' + operatorId)
      .subscribe((data) => {
        
        console.log("Data", data);
        if (data.length > 0) {
          const labSampleLableConfig = data[0]?.SAMPLE_LABELS_CONFIG;
          // Convert array → key/value object for fast lookup
          this.labSampleLabelMap = {};
          if(labSampleLableConfig && labSampleLableConfig.length > 0) {
          labSampleLableConfig.forEach(item => {
            if (item.isChecked) {
              this.labSampleLabelMap[item.standardLabel] = item.newLabel;
            }
          });
        }
          this.displayLoading = false;
          this.changedetector.detectChanges();
          console.log("Label Map", this.labSampleLabelMap);
        } else {
          this.displayLoading = false;
          this.changedetector.detectChanges();
        }
      }, (err) => {
        this.displayLoading = false;
        this.changedetector.detectChanges();
        console.log("Error in fetching report config data", err);
      });
    }

  generateLabFileNumber() {
    //genrate file number;
    let year = new Date().getFullYear();
    let FileNumber = "";

    this.http.get<any>(this.decryptedBaseUrl + '/facility_master_service/facility_master_data/' + this.selectedSampleId)
      .subscribe((data) => {
        console.log("facilityData",data);
        this.companyMasterDataForCount = data;
        //logic for File number
        let sampleCount = data.company_master.COMPANY_COUNT.toString();
        let zerosString = "";
        for (let count = 0; count < 6 - data.company_master.COMPANY_COUNT.toString().length; count++) {
          zerosString = "0" + zerosString;
        }
        sampleCount = zerosString + sampleCount;

        //logic for identifier

        // let sourceDescription = this.labSamplesForm.value.sourceDescription;
        // let identifier = "";
        // if (sourceDescription.toLowerCase().includes("liquid")) {
        //   identifier = "L";
        // }
        // else if (sourceDescription.toLowerCase().includes("gas")) {
        //   identifier = "G";
        // }
        // else {
        //   identifier = "U";
        // }
        console.log("this.labSamplesForm.value.sampleState", this.selectedSampleState);
        if (this.selectedSampleState != null) {
          let identifier = this.selectedSampleState;
          this.labSamplesForm.patchValue({ sampleState: this.selectedSampleState });
          this.labSamplesForm.get('sampleState').markAsTouched();
          FileNumber = year + data.SHORT_NAME + sampleCount + identifier;
          this.labSamplesForm.get('labFileNumber').setValue(FileNumber);
          this.labFileNumber = FileNumber;
        }

        else {
          swal.fire("Warning", "Please select the state of sample first", "warning")
        }
        this.changedetector.detectChanges();

      });
  }

  onenterSamplePointCode(event){
   // console.log("Event",event.target.value)
   console.log("term",event.term)
    const input = event.term
    console.log("inputLength",input.length)
    var body = {
      isCustomer : this.isCustomer,   
    }

    if(this.isCustomer) {
      body["operators"] = this.operatorsOfCustomer.split(",")
    }
    if(input.length == 3){
      
      this.http.post<any>(this.decryptedBaseUrl + `/facility_master_service/get/facility_master_data/${input}`, body)
      .subscribe((companyData) => {
        console.log("companyData",companyData[0])
        companyData.forEach(data => {
          this.filteredSamplePointCode.push({
            ID: data.ID,
            operator : data.company_master.id,
            SAMPLE: data.SAMPLE_POINT_CODE + " | " + data.SAMPLE_POINT_NAME + " | " + data.FACILITY_NAME + " | " + data.OPERATOR
          })
        });
        // console.log("filteredSamplePointCode",this.filteredSamplePointCode)
        this.changedetector.detectChanges();
      })
    }
    else if(input.length > 3) {
      console.log("filteredSamplePointCode",this.filteredSamplePointCode)
      if(this.filteredSamplePointCode.length == 0){
        console.log("inputLength381",input.length)
        this.http.post<any>(this.decryptedBaseUrl + `/facility_master_service/get/facility_master_data/${input}`, body)
        .subscribe((companyData) => {
         console.log("companyData",companyData)
          companyData.forEach(data => {
            this.filteredSamplePointCode.push({
              ID: data.ID,
              operator : data.company_master.id,
              SAMPLE: data.SAMPLE_POINT_CODE + " | " + data.SAMPLE_POINT_NAME + " | " + data.FACILITY_NAME + " | " + data.OPERATOR
            })
          });
          // console.log("filteredSamplePointCode",this.filteredSamplePointCode)
          this.changedetector.detectChanges();
        })
      }else{
      const filteredData = this.filteredSamplePointCode.filter((item) => item.SAMPLE.toLowerCase().includes(input.toLowerCase()))
      this.filteredSamplePointCode = filteredData
      }
    }else if(input.length == 0){
      this.filteredSamplePointCode =[]
    }

  }

  handleAction() {
    this.router.navigate(['/admin/add-sample-point']);
  }

}
